<flx-key-value-display-with-instructions
	*ngFor="let job of jobList$ | async"
	[title]="job.title"
	[headingConfig]="{ color: 'secondary', size: 'small', align: 'center' }"
	[keyValueList$]="job.keyValueList$"
></flx-key-value-display-with-instructions>
